import React from "react";
import CampaignStatusBadge from "./CampaignStatusBadge";
import getImageUrl from "../../../utils/imageUrl";
const CampaignPreview = ({ campaign }) => {

    if (!campaign) return null;

    return (

        <div className="campaign-preview">

            <h3>Campaign Preview</h3>

            {campaign.bannerImage && (

                <img
                    src={getImageUrl(
                        `uploads/campaigns/${campaign.bannerImage}`
                    )}
                    alt={campaign.title}
                    className="campaign-banner"
                />

            )}

            <div className="preview-item">

                <strong>Title</strong>

                <p>{campaign.title}</p>

            </div>

            <div className="preview-item">

                <strong>Description</strong>

                <p>{campaign.description}</p>

            </div>

            <div className="preview-item">

                <strong>Type</strong>

                <p>{campaign.campaignType}</p>

            </div>

            <div className="preview-item">

                <strong>Audience</strong>

                <p>{campaign.targetAudience}</p>

            </div>

            <div className="preview-item">

                <strong>Button Text</strong>

                <p>{campaign.buttonText}</p>

            </div>

            <div className="preview-item">

                <strong>Redirect Type</strong>

                <p>{campaign.redirectType}</p>

            </div>

            <div className="preview-item">

                <strong>Redirect Value</strong>

                <p>{campaign.redirectValue || "-"}</p>

            </div>

            <div className="preview-item">

                <strong>Display Order</strong>

                <p>{campaign.displayOrder}</p>

            </div>

            <div className="preview-item">

                <strong>Status</strong>

                <CampaignStatusBadge
                    status={campaign.status}
                />

            </div>

        </div>

    );

};

export default CampaignPreview;